/**
 * Creative tab — Texts (prompt groups and how many the AI writes, one card)
 * and Text ranking, which opens its own window; a route test has its "Texts
 * on test drops" step there instead (19/10/2026).
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { MessageSquareText } from 'lucide-react';

import { StepCard, StepCardGroup } from '@/components/ui';
import { useTextPromptGroups } from '@/features/campaign-texts/hooks/useTextPromptGroups';

import { InheritedSection } from '../master/InheritedSection';
import type { ContainerEditor } from '../state/useContainerEditor';
import { GenerationStep } from './GenerationStep';
import { PromptGroupsStep } from './PromptGroupsStep';
import { TextRankingStep } from './ranking/TextRankingStep';
import { RouteTestTextsStep } from './route-test/RouteTestTextsStep';
import { textsSummary } from './texts-summary';

export const CreativeTab: FC<{ editor: ContainerEditor; countryKey: string; containerId?: string | null }> = ({ editor, countryKey, containerId = null }) => {
  const tree = useTextPromptGroups().data ?? [];
  return (
    <StepCardGroup>
      <StepCard index={1} icon={MessageSquareText} title="Texts" summary={textsSummary(editor.draft.creative, tree)}>
        <InheritedSection section="creative">
          <div className="flex flex-col gap-5">
            <PromptGroupsStep editor={editor} />
            <div className="border-t border-border/60 pt-4">
              <GenerationStep editor={editor} />
            </div>
          </div>
        </InheritedSection>
      </StepCard>
      {editor.draft.kind === 'ROUTE_TEST' ? (
        <RouteTestTextsStep index={2} editor={editor} countryKey={countryKey} />
      ) : (
        <TextRankingStep index={2} editor={editor} countryKey={countryKey} containerId={containerId} />
      )}
    </StepCardGroup>
  );
};
